import React, { forwardRef, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import filterDateLogo from "../../assets/admin Images/filter-date-logo.svg";

// Date field for the filter popup. Unlike <input type="date">, whose value Chrome rewrites on
// every month switch in its picker, react-datepicker only calls onChange when a day is picked
// (or the field is cleared), so the list is refetched once, right when a date is selected.
// Values in and out are "YYYY-MM-DD" strings, the same format the native input used.

export const FILTER_DATE_POPPER_CLASS = "filter-date-popper";

const toDate = (value) => (value ? moment(value, "YYYY-MM-DD").toDate() : null);

// Same markup as the existing filter date box.
const DateBox = forwardRef(({ value, onClick }, ref) => (
  <div
    ref={ref}
    className="filter-date-container picker-box input-shadow"
    onClick={onClick}
  >
    <div className="filter-date-placeholder f-med">
      {value || "Select a date"}
    </div>
    <img
      src={filterDateLogo}
      alt="filter date logo"
      className="filter-date-logo"
    />
  </div>
));

const FilterDateInput = ({ value, onChange, minDate, maxDate }) => {
  const pickerRef = useRef(null);
  const emit = (date) =>
    onChange(date ? moment(date).format("YYYY-MM-DD") : "");

  return (
    <DatePicker
      ref={pickerRef}
      selected={toDate(value)}
      onChange={emit}
      minDate={toDate(minDate)}
      maxDate={toDate(maxDate)}
      dateFormat="dd-MM-yyyy"
      customInput={<DateBox />}
      popperPlacement="bottom-start"
      // Rendered under <body>: inside the filter popup the calendar is clipped by its scroll, and
      // with position: fixed it opened near the top of the page instead of under the field.
      // FilterBtn's outside-click handler ignores clicks in FILTER_DATE_POPPER_CLASS.
      portalId="filter-date-portal"
      popperClassName={FILTER_DATE_POPPER_CLASS}
      todayButton="Today"
    >
      {value && (
        <button
          type="button"
          className="filter-date-clear"
          onClick={() => {
            emit(null);
            pickerRef.current?.setOpen(false);
          }}
        >
          Clear
        </button>
      )}
    </DatePicker>
  );
};

export default FilterDateInput;
